import { useTranslation } from 'react-i18next';
import { Logo } from '../../components/Logo';

export function WalletScreen({ email }: { address?: string; email?: string }) {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen items-center justify-center px-6 py-10">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 flex justify-center">
          <Logo variant="mark" size={48} />
        </div>
        <p className="font-mono text-[11px] uppercase tracking-eyebrow text-ink-tertiary">
          {t('iframe.wallet.eyebrow')}
        </p>
        {email && <p className="mt-3 text-xs text-ink-tertiary">{email}</p>}
        <p className="mt-6 text-xs leading-relaxed text-ink-tertiary">{t('iframe.wallet.body')}</p>
      </div>
    </main>
  );
}
